import { render, staticRenderFns } from "./proposal-evaluation-component.vue?vue&type=template&id=d4ebbbca&scoped=true&"
import script from "./proposal-evaluation-component.vue?vue&type=script&lang=ts&"
export * from "./proposal-evaluation-component.vue?vue&type=script&lang=ts&"
import style0 from "./proposal-evaluation-component.vue?vue&type=style&index=0&id=d4ebbbca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ebbbca",
  null
  
)

export default component.exports